module.exports = __webpack_public_path__ + "img/chart-waterfall.dcd21e44.svg";